// extracted by mini-css-extract-plugin
export default {"container":"fM-z","modal":"gM-z","dimensions":"hM-z","brandName":"iM-z","productName":"jM-z","labelValue":"kM-z","recipientEmail":"lM-z","recommendedFit":"mM-z","hiddenField":"nM-z"};